import InputCheck from './InputCheck';

export default InputCheck;